<template>
  <el-container v-title data-title="卡号修改记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
                <el-breadcrumb-item>卡号修改记录</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.realName" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="班级" filterable>
                  <el-select v-model="searchForm.classId">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in selectingClassList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getUserCardNoChangeHistoryList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="userName" label="用户名" width="140"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="140"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="200"></el-table-column>
          <el-table-column prop="classNames" label="班级" width="90"></el-table-column>
          <el-table-column prop="cardNoBefore" label="卡号1修改前" width="110"></el-table-column>
          <el-table-column prop="cardNo2Before" label="卡号2修改前" width="110"></el-table-column>
          <el-table-column prop="cardNoAfter" label="卡号1修改后" width="110"></el-table-column>
          <el-table-column prop="cardNo2After" label="卡号2修改后" width="110"></el-table-column>
          <el-table-column prop="insertTime" label="修改时间" width="160"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getUserCardNoChangeHistoryList"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        realName: '',
        schoolId: '',
        classId: ''
      },
      schoolList: [],
      classList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      if (['1', '2'].indexOf(this.userInfo.userType) !== -1) {
        this.getSchoolList()
        this.getClassList()
      }
      this.getUserCardNoChangeHistoryList()
    }
  },
  created () {
    let _this = this
    document.onkeydown = function (e) {
      if (window.event.keyCode === 13) {
        _this.getUserCardNoChangeHistoryList()
      }
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getUserList()
    },
    getUserCardNoChangeHistoryList (currentPage) {
      let _this = this
      _this.currentPage = typeof currentPage === 'number' ? currentPage : _this.currentPage
      let params = {
        currentUserId: _this.userInfo.id,
        page: _this.currentPage,
        size: _this.pageSize,
        realName: _this.searchForm.realName,
        schoolId: _this.searchForm.schoolId,
        classId: _this.searchForm.classId
      }
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/userCardNoChangeHistory/list',
        this.$qs.stringify(params)
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getClassList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.classList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    }
  },
  computed: {
    selectingClassList () {
      let tempArray = []
      if (this.searchForm.schoolId != null) {
        this.classList.forEach(classInfo => {
          if (classInfo.schoolId === this.searchForm.schoolId) {
            tempArray.push(classInfo)
          }
        })
      } else {
        tempArray = this.classList
      }
      return tempArray
    }
  },
  watch: {
    selectingClassList () {
      if (this.searchForm.classId != null && this.selectingClassList.map(item => item.id).indexOf(this.searchForm.classId) === -1) {
        this.searchForm.classId = ''
      }
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/UserCardNoChangeHistory.vue